import { getSelfieCamConfig } from '../../helpers/api';

export const fetchConfig = () => getSelfieCamConfig().catch((err) => {
  console.warn('fetchConfig: failed', err);
  throw err;
});

export const getSelfieCamFromEvent = (evt) => evt?.selfieCam || evt?.selfiecam || null;

/** Normalized selfieCam block from config (selfieCam, selfiecam, config.event, or root). */
export const getSelfieCam = (config) => {
  if (!config) return null;
  const nested = config.selfieCam || config.selfiecam;
  if (nested) return nested;
  const fromEvent = config.event && (config.event.selfieCam || config.event.selfiecam);
  if (fromEvent) return fromEvent;
  const hasRoot = typeof config.language === 'object'
    || (config.colors && typeof config.colors === 'object');
  return hasRoot ? config : null;
};
